import { useContext } from 'react';
import { ProjectEditorContext } from '.';

export const useProjectEditor = () => useContext(ProjectEditorContext);
